import { render, staticRenderFns } from "./ClickEventWrapper.vue?vue&type=template&id=bbc1e42a&"
import script from "./ClickEventWrapper.vue?vue&type=script&lang=js&"
export * from "./ClickEventWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports